import React from "react";
import { Link } from "react-router-dom";
import { SMS_CONSENT_TEXT_LEAD } from "@/lib/commercialConsent";

// Commercial marketing opt-ins (email / SMS). Always unchecked by default and never
// required to submit the form. `variant` adapts colors to dark vs light backgrounds.
const TONES = {
  onDark: { text: "text-white/75", sms: "text-white/55", link: "text-white underline underline-offset-2 decoration-[#B3A17D]", accent: "accent-[#B3A17D]" },
  onLight: { text: "text-[#6B4954]", sms: "text-[#897756]", link: "text-[#451C25] underline underline-offset-2 decoration-[#B3A17D]", accent: "accent-[#451C25]" },
};

export function CommsConsent({
  variant = "onLight",
  showEmail = false,
  showSms = false,
  email = false,
  sms = false,
  onEmailChange,
  onSmsChange,
  className = "",
}) {
  const t = TONES[variant] || TONES.onLight;
  if (!showEmail && !showSms) return null;
  return (
    <div data-testid="comms-consent" className={`space-y-3 ${className}`}>
      {showEmail && (
        <label className="flex items-start gap-2.5 cursor-pointer" data-testid="consent-email-label">
          <input
            type="checkbox"
            data-testid="consent-email-marketing"
            checked={!!email}
            onChange={(e) => onEmailChange?.(e.target.checked)}
            className={`mt-0.5 h-4 w-4 shrink-0 ${t.accent}`}
          />
          <span className={`text-[13px] leading-relaxed ${t.text}`}>
            Email me occasional tips and updates about moving to Spain. Optional — unsubscribe anytime.
          </span>
        </label>
      )}
      {showSms && (
        <label className="flex items-start gap-2.5 cursor-pointer" data-testid="consent-sms-label">
          <input
            type="checkbox"
            data-testid="consent-sms-marketing"
            checked={!!sms}
            onChange={(e) => onSmsChange?.(e.target.checked)}
            className={`mt-0.5 h-4 w-4 shrink-0 ${t.accent}`}
          />
          <span className={`text-[12px] leading-relaxed ${t.sms}`}>
            {SMS_CONSENT_TEXT_LEAD} See our <Link to="/privacy" className={t.link}>Privacy Policy</Link> and{" "}
            <Link to="/terms" className={t.link}>Terms</Link>.
          </span>
        </label>
      )}
    </div>
  );
}

export default CommsConsent;
